import React, {PureComponent, Fragment} from 'react';
import ViewForm, {ViewFormField, EmptyMsg} from './ViewForm';
import {GridColumn} from '@atlaskit/page';
import {TextField} from '../../../components/FormFields';
import Button, {ButtonGroup} from '@atlaskit/button';
import {FormFooter} from '@atlaskit/form';
import {EditViewContext} from './EditViewContext';
import TrashIcon from '@atlaskit/icon/glyph/trash';
import i18n from 'i18next';
import {Trans} from 'react-i18next';

const AgentEditItem = ({
  fullName,
  phone,
  fetching,
  onChange,
  onRemove,
}) => (
  <Fragment>
    <GridColumn medium={6}>
      <TextField
        name='fullName'
        label={i18n.t('clients:Full name')}
        placeholder={i18n.t('clients:Enter full name')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={fullName}
      />
    </GridColumn>
    <GridColumn medium={6}>
      <div style={{display: 'flex', alignItems: 'flex-end'}}>
        <div style={{flexGrow: 1}}>
          <TextField
            name='phone'
            label={i18n.t('clients:Phone')}
            placeholder={i18n.t('clients:Enter phone number')}
            required={true}
            onChange={onChange}
            isDisabled={fetching}
            value={phone}
          />
        </div>
        <div style={{margin: 4}}>
          <Button
            appearance='subtle'
            iconBefore={<TrashIcon primaryColor='red' />}
            onClick={onRemove}
            isDisabled={fetching}
          />
        </div>
      </div>
    </GridColumn>
  </Fragment>
)

class AgentsEditForm extends PureComponent {

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fetching 
      && prevProps.fetching !== this.props.fetching
      && !this.props.error) {
        this.props.onChangeEditMode();
    }
  }

  onFieldChange = index => (name, value) => {
    const {agents, onChange} = this.props;
    const objValue = JSON.parse(JSON.stringify(agents)); //deep clone
    objValue[index][name] = value;
    onChange('agents', objValue);
  }

  onRemove = index => () => {
    const {agents, onChange} = this.props;
    const value = [...agents];
    value.splice(index, 1);
    onChange('agents', value);
  }

  onCancel = () => {
    this.props.onChangeEditMode();
    this.props.onCancel();
  }

  render() {
    const {
      agents,
      onChange,
      fetching,
    } = this.props;

    return (
      <Fragment>
        {agents && agents.length && agents.length > 0 ? agents.map((agent, index) => (
          <AgentEditItem
            key={`agent_item_${index}`}
            {...agent}
            onChange={this.onFieldChange(index)}
            onRemove={this.onRemove(index)}
            fetching={fetching}
          />
        )) : (
          null
        )}
        <GridColumn medium={12}>
          <div style={{paddingTop:16}}>
          <Button isDisabled={fetching} onClick={() => onChange('agents',[...agents, {fullName:'', phone:''}])}>
            {i18n.t('clients:Add confidant')}
          </Button>
          </div>
        </GridColumn>
        <GridColumn medium={12}>
          <FormFooter>
            <ButtonGroup>
              <Button appearance='subtle' isDisabled={fetching} onClick={this.onCancel}>
                <Trans>
                  Cancel
                </Trans>
              </Button>
              <Button type='submit' isDisabled={fetching} isLoading={fetching} appearance='danger'>
                <Trans>
                  Save
                </Trans>
              </Button>
            </ButtonGroup>
          </FormFooter>
        </GridColumn>
      </Fragment>
    )
  }
}

const AgentViewItem = ({fullName, phone}) => (
  <Fragment>
    <ViewFormField
      label={i18n.t('clients:Full name')}
      value={fullName}
      gridColumn={6}
    />
    <ViewFormField
      label={i18n.t('clients:Phone')}
      value={phone}
      gridColumn={6}
    />
  </Fragment>
)

const AgentsViewForm = ({agents}) => (
  <Fragment>
    {agents && agents.length && agents.length > 0 ? agents.map((agent, index) => (
      <AgentViewItem key={`agent_item_${index}`} {...agent} />
    )) : (
      <EmptyMsg msg={i18n.t('clients:No confidants')} />
    )}
  </Fragment>
)

export default props => {
  const formName = 'carAgents';
  return (
    <EditViewContext.Consumer>
      {({edit, permissions, onChangeEditMode}) => permissions.car && permissions.car.agents && (
        <ViewForm
          formName={formName}
          title={i18n.t('clients:Confidants')}
          actionName={permissions.car.agents.edit && i18n.t('Edit')}
          action={onChangeEditMode(formName)}
          editMode={edit === formName}
        >
          {edit === formName
            ? <AgentsEditForm {...props} onChangeEditMode={onChangeEditMode(formName)}/>
            : <AgentsViewForm {...props} />}
        </ViewForm>
      )}
    </EditViewContext.Consumer>
  );
};
